import { TableLazyLoadEvent } from "primeng/table";
import { IColumn } from "../shared/interfaces/column.interface";
import { MessageService } from "primeng/api";
import { IProcess } from '../shared/interfaces/process.interface';
import { TypesEvents } from "./enums/types_events";
import { FormGroup } from "@angular/forms";
import { Statuses } from "./enums/statuses";
import { TagsStyles } from "./enums/tags-styles";

class Utils {

  isValidFieldForm(form: FormGroup, field: string):  boolean | null {
    return form.controls[field].errors
     && form.controls[field].touched
  }

  getFieldErrorForm(form: FormGroup, field: string): string | null{
    if(!form.controls[field]) return null;

    const errors = form.controls[field].errors || {};

    for(const key of Object.keys(errors)){
      switch(key){
        case 'required':
          return 'Este campo es obligatorio';

        case 'minlength':
          return `Se requieren mínimo ${errors['minlength'].requiredLength} caracters`;

        case 'email':
          return 'Debes ingresar un email';
      }
    }

    return null;
  }

  getParamsQuery(size: number, cols: IColumn[], event: TableLazyLoadEvent ): string {
    let query : string = '';

    cols.forEach(col => {
      if(col.field){
        if(event.filters![`${col.field}`] != undefined) {
          const filter = event.filters![`${col.field}`] as any;
          const filterValue = filter[0].value;
          if(filter[0].value != undefined){
              query = `${query}&${col.field}=${filterValue}`;
          }
        }
      }
    });

    const page: string = `${event.first! / event.rows!}`;

    let colSorteable: string = '';
    let order: string = '';
    if(event.sortField != undefined) {
      colSorteable = `&orderColumn=${event.sortField}&`
      order = `order=${event.sortOrder}`;
    }

    return `page=${page}&sizeIndicator=${size}${colSorteable}${order}${query}`;
  }

  showListenedMessage(value: IProcess, messageService: MessageService, confirmations: any, severity = 'success') {
    switch(value.event) {
      case TypesEvents.ADD:
        messageService.add({
          severity: severity,
          summary: 'Confirmación.',
          detail: confirmations.add
        });
      break;
      case TypesEvents.EDIT:
        messageService.add({
          severity: severity,
          summary: 'Confirmación',
          detail: confirmations.edit
        });
      break;
      case TypesEvents.FINISH:
        messageService.add({
          severity: severity,
          summary: 'Confirmación',
          detail: confirmations.finish
        });
      break;
      case TypesEvents.ERROR:
        messageService.add({key: 'error', severity: 'error', sticky: true });
      break;
      case TypesEvents.ERROR_IMAGES:
        messageService.add({key: 'error', severity: 'error', sticky: true });
      break;
    }
  }

  managmentExcelFile(response: any, fileName: string): void{
    const dataType = response.type;
    const binaryData = [];
    binaryData.push(response);

    const filePath = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
    const downloadLink = document.createElement('a');
    downloadLink.href = filePath;
    downloadLink.setAttribute('download', `${fileName}`);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  getStatusStyle(statusId: string) {
    let style: TagsStyles =  TagsStyles.SUCCESS;
    switch(statusId) {
      case Statuses.CREATED:
        style = TagsStyles.WARNING;
      break;
      case Statuses.DENIED:
        style = TagsStyles.WARNING;
      break;
      case Statuses.FINALIZED:
        style = TagsStyles.INFO;
      break;
    }

    return style;
  }

  replacetHtmlTags(text: string): string {
      return  text.replace( /(<([^>]+)>)/ig, ' ');
  }
}

const utils = new Utils();

export default utils;
